<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-btn
      icon
      slot="activator"
    >
      <v-icon color="primary">edit</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Lieferant bearbeiten</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                label="Branchenname"
                required
                v-model="localBranch.title"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Icon"
                required
                v-model="localBranch.icon"
                :disabled="loading"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="update()" :loading="loading">Speichern</v-btn>
        <v-btn color="red darken-1" flat @click.native="dialog = false">Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DlgBranchEdit',
  components: {
  },
  data() {
    return {
      dialog: false,
      loading: false,
      localBranch: {},
    };
  },
  props: ['branch'],
  methods: {
    ...mapActions({
      branchUpdate: 'branch/update',
      branchRead: 'branch/read',
    }),
    update() {
      this.loading = true;
      this.branchUpdate(this.localBranch).then((res) => {
        this.loading = false;
        if (res) {
          this.branchRead();
          this.localBranch = {};
          this.dialog = false;
        }
      });
    },
  },
  watch: {
    dialog() {
      this.localBranch = JSON.parse(JSON.stringify(this.branch));
    },
  },
};
</script>

<style scoped>

</style>
